export const selectCustomerState = state => state.customer;
export const selectCustomerById = (state, customerID) =>
  state.customer.customers.find(customer => customer.user.id === customerID);
export const selectCurrentCustomer = state => state.customer.currentCustomer;

export const selectAllCustomers = state => state.customer.customers;
export const selectCustomersLoading = state => state.customer.isLoading;
export const selectCustomersError = state => state.customer.error;
